<template>
  <div class="subpage">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in this.carDrive.text.pageNavbar"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page :options="options" id="fullpage" ref="fullpage">
      <div
        class="subpage-header section fp-auto-height-responsive"
        data-anchor="drive"
      >
        <video-background
          :autoplay="true"
          :loop="true"
          :poster="require('@/assets/images/video-background.jpg')"
          :src="require('@/assets/videos/flat-naped-top2-ec-phev.mp4')"
          @ready="startInterval"
          data-ref="flatDrive"
          ref="flatDrive"
          class="set-position"
        >
        </video-background>
        <div class="section-container">
          <div class="section-wrapper text-right">
            <h2
              class="uppercase header"
              data-aos="text-focus-in"
              data-aos-duration="500"
            >
              Innowacje służace <span>osiągom</span>
            </h2>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="400"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=R5x1-pVrNB0"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.carDrive.text.electricButton }}
            </v-btn>-->
            <p
              class="description"
              data-aos="text-focus-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.headerDesc }}
            </p>
          </div>
        </div>
        <div class="movie-text">
          <div
            :key="index"
            class="movie-text-container"
            v-for="(text, index) in this.carDrive.text.headerMovieDesc"
          >
            <h5 class="uppercase header-sub">
              {{ text.header }}
            </h5>
            <p class="description">
              {{ text.desc }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="automatic-drive section fp-auto-height-responsive"
        data-anchor="automatic-drive"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <div class="text-wrapper">
              <h5
                class="header-sub uppercase"
                data-aos="fade-down"
                data-aos-duration="500"
              >
                Innowacje
              </h5>
              <h3
                class="header text-uppercase"
                data-aos="fade-down"
                data-aos-delay="150"
                data-aos-duration="500"
              >
                Automatyczne tryby jazdy
              </h3>
            </div>
            <swiper
              :options="carDrive.innovationsSlider"
              class="swiper slider-flex"
              ref="innovationSlider"
            >
              <swiper-slide class="slider-item">
                <div class="slider-text">
                  <div class="text-wrapper">
                    <div
                      class="buttons"
                      data-aos="text-focus-in"
                      data-aos-delay="700"
                      data-aos-duration="500"
                    >
                      <v-btn
                        :class="
                          carDrive.innovationSliderActiveIndex === 0
                            ? 'mmc-red text'
                            : 'only-text'
                        "
                        @click="goToInnovationPage(0, 'electric-drive')"
                        v-ripple="{ class: 'ripple-red' }"
                        >Jazda elektryczna
                      </v-btn>
                      <v-btn
                        :class="
                          carDrive.innovationSliderActiveIndex === 1
                            ? 'mmc-red text'
                            : 'only-text'
                        "
                        @click="goToInnovationPage(1, 'hybrid-drive')"
                        v-ripple="{ class: 'ripple-red' }"
                        >Jazda hybrydowa
                      </v-btn>
                    </div>
                    <h5
                      class="uppercase"
                      data-aos="zoom-in"
                      data-aos-delay="100"
                      data-aos-duration="500"
                    >
                      Tryb elektryczny
                    </h5>
                    <p
                      class="description margin"
                      data-aos="zoom-in"
                      data-aos-delay="150"
                      data-aos-duration="500"
                    >
                      Silniki elektryczne napędzają samochód, czerpiąc energię z
                      baterii. Zużycie paliwa i emisja CO₂ są wówczas zerowe.
                      Napęd działający w tym trybie jest cichy, ekologiczny i
                      wydajny. Prędkość maksymalna wynosi około 135 km/h. Zasięg
                      w tym trybie wynosi do 45-55 km wg WLTP.
                    </p>
                    <!--<v-btn
                      :class="'mmc-red background'"
                      class="gallery"
                      data-aos="text-focus-in"
                      data-aos-delay="400"
                      data-aos-duration="1000"
                      data-selector=".movie"
                      v-ripple="{ class: 'ripple-red' }"
                    >
                      <span
                        class="movie"
                        data-src="https://www.youtube.com/watch?v=UgsbmW2tORc"
                      ></span>
                      <i class="fas fa-play"></i>
                      {{ this.carDrive.text.electricButton }}
                    </v-btn>-->
                    <img
                      data-aos="zoom-in"
                      data-aos-delay="600"
                      data-aos-duration="500"
                      src="../assets/images/8_lat_gwarancji.png"
                      alt="8 lat gwarancji"
                    />
                  </div>
                </div>
                <div class="slider-image">
                  <video-background
                    :autoplay="false"
                    :loop="false"
                    :poster="
                      require('@/assets/images/cardrive/car-movieec-phev.jpg')
                    "
                    :src="
                      require('@/assets/videos/Electric-driving-ec-phev.mp4')
                    "
                    @ended="sliderVideoStart('electric-drive', 'safetyRoad')"
                    @ready="sliderVideoStart('electric-drive', 'safetyRoad')"
                    data-ref="electric-drive"
                    ref="electric-drive"
                  >
                  </video-background>
                </div>
              </swiper-slide>
              <swiper-slide class="slider-item">
                <div class="slider-text">
                  <div class="text-wrapper">
                    <div
                      class="buttons"
                      data-aos="text-focus-in"
                      data-aos-delay="700"
                      data-aos-duration="500"
                    >
                      <v-btn
                        :class="
                          carDrive.innovationSliderActiveIndex === 0
                            ? 'mmc-red text'
                            : 'only-text'
                        "
                        @click="goToInnovationPage(0, 'electric-drive')"
                        v-ripple="{ class: 'ripple-red' }"
                        >Jazda elektryczna
                      </v-btn>
                      <v-btn
                        :class="
                          carDrive.innovationSliderActiveIndex === 1
                            ? 'mmc-red text'
                            : 'only-text'
                        "
                        @click="goToInnovationPage(1, 'hybrid-drive')"
                        v-ripple="{ class: 'ripple-red' }"
                        >Jazda hybrydowa
                      </v-btn>
                    </div>
                    <h5
                      class="uppercase"
                      data-aos="zoom-in"
                      data-aos-delay="100"
                      data-aos-duration="500"
                    >
                      Tryb szeregowy
                    </h5>
                    <p
                      class="description margin"
                      data-aos="zoom-in"
                      data-aos-delay="150"
                      data-aos-duration="500"
                    >
                      Napęd elektryczny wspomagany jest silnikiem spalinowym,
                      który służy jako generator ładując baterię. Aktywuje się
                      gdy poziom naładowania baterii jest niski oraz w
                      sytuacjach zwiększonego zapotrzebowania na moc.
                    </p>
                    <h5
                      class="uppercase"
                      data-aos="zoom-in"
                      data-aos-delay="200"
                      data-aos-duration="500"
                    >
                      Tryb równoległy
                    </h5>
                    <p
                      class="description margin"
                      data-aos="zoom-in"
                      data-aos-delay="250"
                      data-aos-duration="500"
                    >
                      Napęd spalinowy wspomagany jest silnikami elektrycznymi
                      np. przy dużej prędkości i maksymalnemu zapotrzebowaniu na
                      moc. Auto generuje łącznie 188 KM mocy zapewniając
                      dynamikę i przyjemność z jazdy.
                    </p>
                    <!--<v-btn
                      :class="'mmc-red background'"
                      class="gallery"
                      data-aos="text-focus-in"
                      data-aos-delay="400"
                      data-aos-duration="1000"
                      data-selector=".movie"
                      v-ripple="{ class: 'ripple-red' }"
                    >
                      <span
                        class="movie"
                        data-src="https://www.youtube.com/watch?v=oYrGNKXpoBk"
                      ></span>
                      <i class="fas fa-play"></i>
                      {{ this.carDrive.text.electricButton }}
                    </v-btn>-->
                  </div>
                </div>
                <div class="slider-image">
                  <video-background
                    :autoplay="false"
                    :loop="false"
                    :poster="
                      require('@/assets/images/cardrive/car-movieec-phev.jpg')
                    "
                    :src="require('@/assets/videos/Hybrid-driving-ec-phev.mp4')"
                    @ended="sliderVideoStart('hybrid-drive', 'safetyRoad')"
                    @ready="sliderVideoStart('hybrid-drive', 'safetyRoad')"
                    data-ref="hybrid-drive"
                    ref="hybrid-drive"
                  >
                  </video-background>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div
        class="electric section fp-auto-height-responsive"
        data-anchor="electric"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.electricSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.electricHeader }}
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.electricDesc }}
            </p>
            <!--<v-btn
              :class="'mmc-red background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="600"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-red' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=Ps6Nzl_2hU8"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.carDrive.text.electricButton }}
            </v-btn>-->
          </div>
        </div>
      </div>
      <div
        class="text-two-images section fp-auto-height-responsive"
        data-anchor="more"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedHeader }}
            </h2>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedEasy }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedEasyDesc }}
              <!--<span
                >* - Zasilanie prądem 230V (16A). 6 godzin w przypadku zasilania
                230 V (10A).</span
              >-->
            </p>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="600"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedMode }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="750"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedModeDesc }}
            </p>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="900"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedPower }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="1050"
              data-aos-duration="500"
            >
              {{ this.carDrive.text.advancedPowerDesc }}
            </p>
          </div>
        </div>
        <div class="side-gallery gallery" data-selector="div">
          <div
            :data-aos-delay="index * 150"
            :data-src="require('@/assets/images/cardrive/' + image)"
            :key="index"
            :style="{
              backgroundImage:
                'url(' + require('@/assets/images/cardrive/' + image) + ')'
            }"
            data-aos="zoom-in"
            data-aos-duration="500"
            v-for="(image, index) of this.carDrive.text.advancedImages"
          >
            <i class="fas fa-image"></i>
          </div>
        </div>
      </div>
      <div
        class="footer section fp-auto-height-responsive"
        data-anchor="features"
      >
        <div class="section-container">
          <swiper
            :options="carDrive.mainSlider"
            @resize="sliderResize"
            @slideChange="updatePaginationIndex"
            class="swiper slider-flex"
            ref="mainSlider"
          >
            <swiper-slide
              :key="slider.header"
              class="slider-item"
              v-for="slider in this.carDrive.text.footerSlider"
            >
              <div
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/cardrive/' + slider.background) +
                    ')'
                }"
                class="background"
              ></div>
              <div class="slider-text">
                <div class="text-wrapper">
                  <h3 class="header text-uppercase">{{ slider.header }}</h3>
                  <p>{{ slider.description }}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="arrows">
            <i @click="prevSlide" class="fas fa-angle-left"></i>
            <i @click="nextSlide" class="fas fa-angle-right"></i>
          </div>
          <div class="dots">
            <div
              :class="
                index === carDrive.mainSliderActiveIndex ? 'current-slide' : ''
              "
              :key="index"
              @click="goToPage(index)"
              class="dot"
              v-for="(dot, index) in this.carDrive.text.footerSlider"
            ></div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import VideoBackground from "vue-responsive-video-background-player";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CarDrive",
  data: function() {
    return {
      videoReady: false,
      intervalTimes: [0, 8000, 17000, 25000, 33000, 41000, 48000],
      movieSetTimeout: [],
      movieSetInterval: [],
      textContainer: [],
      options: {
        licenseKey: "3AAF9650-2EB641C5-91E1ED66-B5D30F2B",
        scrollBar: true,
        verticalCentered: false,
        menu: ".page-navbar ul",
        responsiveWidth: 767,
        responsiveHeight: 650,
        scrollingSpeed: 0,
        loopTop: true,
        loopBottom: true,
        paddingTop: 0,
        paddingBottom: 0,
        onLeave: this.onLeave
      }
    };
  },
  components: {
    VideoBackground,
    swiper,
    swiperSlide,
    FullPage,
    Footer
  },
  computed: {
    ...mapGetters({
      carDrive: "carDrive",
      header: "header"
    })
  },
  methods: {
    ...mapMutations({
      changeSliderPage: "changeSliderPage",
      changeInnovationSliderPage: "changeInnovationSliderPage"
    }),
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".subpage-header"
      ).offsetHeight;
    },
    goToInnovationPage(value, ref) {
      const activeSlide = document
        .querySelector(
          'div[data-anchor="automatic-drive"] .swiper-slide-active .vue-responsive-videobg'
        )
        .getAttribute("data-ref");
      this.$refs[activeSlide].player.pause();
      this.$refs[ref].player.play();
      this.$refs.innovationSlider.swiper.slideTo(value);
      this.changeInnovationSliderPage(
        this.$refs.innovationSlider.swiper.realIndex
      );
    },
    sliderVideoStart(ref, slider) {
      const activeSlide = document.querySelector(".fp-section.active");

      if (activeSlide) {
        const slide = document.querySelector(
          ".fp-section.active .swiper-slide-active .vue-responsive-videobg"
        );

        if (slide !== null) {
          if (ref === slide.getAttribute("data-ref")) {
            this.$refs[ref].player.play();
          }
        }
      }
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    sliderResize() {
      this.$refs.mainSlider.swiper.update();
    },
    prevSlide() {
      this.$refs.mainSlider.swiper.slidePrev();
      this.updatePaginationIndex();
    },
    nextSlide() {
      this.$refs.mainSlider.swiper.slideNext();
      this.updatePaginationIndex();
    },
    goToPage(value) {
      this.$refs.mainSlider.swiper.slideToLoop(value);
      this.updatePaginationIndex();
    },
    updatePaginationIndex() {
      this.changeSliderPage(this.$refs.mainSlider.swiper.realIndex);
    },
    setIntervalMovie() {
      this.clearMovieIntervals();

      for (let i = 0; i < this.intervalTimes.length - 1; i++) {
        this.movieSetTimeout.push(
          setTimeout(() => {
            this.textContainer.forEach(e => e.classList.remove("active"));
            this.textContainer[i].classList.add("active");

            if (i === this.intervalTimes.length - 2) {
              this.movieSetInterval.push(
                setInterval(() => {
                  clearTimeout(this.movieSetTimeout);
                  this.setIntervalMovie();
                }, 8000)
              );
            }
          }, this.intervalTimes[i])
        );
      }
    },
    startInterval() {
      if (!this.videoReady) {
        this.videoReady = true;
        this.setIntervalMovie();
      }
    },
    clearMovieIntervals() {
      this.movieSetTimeout.forEach(e => clearTimeout(e));
      this.movieSetInterval.forEach(e => clearInterval(e));
    },
    resetMainVideo(name) {
      this.clearMovieIntervals();

      this.$refs[name].player.$refs.video.currentTime = 0;
      this.$refs[name].player.play();

      this.setIntervalMovie();
    },
    onLeave(origin, destination, direction) {
      if (destination.item.classList.contains("subpage-header")) {
        const ref = destination.item
          .querySelector(".vue-responsive-videobg")
          .getAttribute("data-ref");

        if (ref === "flatDrive") {
          this.resetMainVideo(ref);
        } else {
          this.$refs[ref].player.play();
        }
      } else if (destination.item.classList.contains("automatic-drive")) {
        const ref = destination.item
          .querySelector(".swiper-slide-active .vue-responsive-videobg")
          .getAttribute("data-ref");
        this.$refs[ref].player.play();
      }

      if (origin.item.classList.contains("subpage-header")) {
        this.clearMovieIntervals();
      }
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");
    const header = document.querySelector("header .menu-list");

    galleries.forEach(e => {
      window.lightGallery(e, {
        selector: e.getAttribute("data-selector"),
        download: false,
        autoplay: false,
        videoMaxWidth: "1920px"
      });
    });

    body.classList.add("no-overflow");
    header.classList.add("bg-white");

    this.$refs.mainSlider.swiper.update();
    this.textContainer = document.querySelectorAll(".movie-text-container");

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);
  },
  beforeDestroy() {
    const header = document.querySelector("header .menu-list");
    header.classList.remove("bg-white");
    window.removeEventListener("resize", this.updateHomeHeaderSize);
    this.clearMovieIntervals();
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/mixins";
@import "src/styles/page-navbar";
@import "src/styles/footer-subpage";
@import "src/styles/text-two-images";

.subpage-header {
  padding: var(--page-offset);

  .vue-responsive-videobg {
    @include set-position(absolute, 0, 0, 0, 0);
    @include set-size(100%, 100%);
  }

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;
    padding: var(--page-offset);
    align-content: center;
    justify-content: flex-end;

    .section-wrapper {
      width: 50%;

      @media screen and (max-width: $screen-md) {
        width: 75%;
      }

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header {
        span {
          color: $mmc-blue;
        }
      }

      .description {
        color: $white;
        margin: 1rem 0 0;
      }
    }
  }

  .movie-text {
    @include set-position(absolute, auto, 0, var(--page-offset), 0);
    z-index: 1;

    @media screen and (max-height: $screen-height-es) {
      position: relative;
    }

    @media screen and (max-width: $screen-sm) {
      position: relative;
    }

    .movie-text-container {
      @include set-position(absolute, auto, 0, 0, 0);
      padding: 0 calc(2 * var(--page-offset));
      box-sizing: border-box;
      transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
      width: calc(33% + 2 * var(--page-offset));
      opacity: 0;

      &.active {
        opacity: 1;
      }

      @media screen and (max-width: $screen-md) {
        width: calc(67% + 2 * var(--page-offset));
      }

      @media screen and (max-height: $screen-height-es) {
        position: relative;
        display: none;
        width: 100%;
        padding: var(--page-offset) var(--page-offset) 0;

        &.active {
          display: block;
        }
      }

      @media screen and (max-width: $screen-sm) {
        position: relative;
        display: none;
        width: 100%;
        padding: var(--page-offset) var(--page-offset) 0;

        &.active {
          display: block;
        }
      }

      .description {
        @include font-size-color(0.85rem !important, #c7c7c7 !important);
        margin-top: 1rem;
        margin-bottom: 0 !important;
      }
    }
  }
}

.automatic-drive {
  .section-wrapper {
    @include display-flex(flex, wrap);
    align-content: flex-end;
    align-items: flex-end;
    height: 100vh;

    @media screen and (max-height: $screen-height-es) {
      height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      height: auto;
    }

    > .text-wrapper {
      @include size-flex(100%);
      padding: var(--page-offset) calc(2 * var(--page-offset)) 0;

      .header-sub {
        color: $mmc-blue;
      }

      .header {
        color: $black;
      }
    }
  }

  .slider-item {
    height: auto;

    @media screen and (max-width: $screen-sm) {
      height: fit-content;
    }

    &.swiper-slide-active {
      z-index: 1;
    }

    .slider-text {
      @include display-flex(flex, wrap);
      @include size-flex(50%);
      align-content: center;
      flex-direction: column;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
      }

      .text-wrapper {
        padding: 0 var(--page-offset) var(--page-offset)
          calc(2 * var(--page-offset));

        .header {
          color: $black;

          sup {
            color: $black;
          }
        }

        h5 {
          @include font-size-color(1rem, $slider-description);
          font-weight: 900;
        }

        p {
          color: $slider-description;

          @media screen and (max-height: $screen-height-md) {
            font-size: 0.8rem !important;
            margin-bottom: 1.5rem !important;
          }

          @media screen and (max-width: $screen-lg) {
            font-size: 0.8rem !important;
            margin-bottom: 1.5rem !important;
          }

          @media screen and (max-width: $screen-sm) {
            font-size: 0.9rem !important;
            margin-bottom: 2rem !important;
          }

          &.margin {
            margin-bottom: 1rem !important;
          }

          sup {
            color: $slider-description;
          }
        }

        > .v-btn {
          margin-top: 1.5rem;

          @media screen and (max-width: $screen-es) {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
        }

        img {
          display: block;
          margin-top: 1.5rem;
          max-width: 8rem;
          padding: 0;
        }

        .buttons {
          margin-bottom: 1.5rem;

          .v-btn {
            padding: 0.5rem 1rem !important;
            height: 2rem !important;
            font-weight: 500 !important;

            &:first-of-type {
              margin-right: 1rem;
            }

            &.only-text {
              color: $black !important;
              box-shadow: none;
              border-color: transparent;
            }

            @media screen and (max-width: $screen-xl) {
              letter-spacing: 0 !important;
              font-size: 1rem !important;
            }

            @media screen and (max-width: $screen-lg) {
              padding: 0.15rem 1rem !important;
              font-size: 0.65rem !important;
              min-width: auto !important;

              &:first-of-type {
                margin-right: 0.5rem;
              }
            }

            @media screen and (max-width: $screen-xs) {
              box-sizing: border-box !important;
              height: auto !important;
              margin-right: 0 !important;
            }
          }
        }
      }
    }

    .slider-image {
      @include display-flex(flex, wrap);
      @include size-flex(50%);
      align-content: flex-end;
      position: relative;

      &::after {
        @include set-position(absolute, auto, 0, 0, auto);
        @include set-size(87.5%, 20%);
        content: "";
        background-color: $mmc-gray-light;
        display: none;

        @media screen and (max-width: 1780px) {
          display: block;
        }

        @media screen and (max-width: $screen-lg) {
          height: 25%;
        }

        @media screen and (max-width: 850px) {
          height: 30%;
        }

        @media screen and (max-width: $screen-sm) {
          display: none;
        }
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
      }

      .vue-responsive-videobg {
        height: 100%;

        @media screen and (max-width: $screen-sm) {
          height: 300px;
        }
      }
    }
  }
}

.electric {
  @include display-flex(flex, wrap);
  @include set-background(no-repatc, right top, cover);
  background-image: url("../assets/images/cardrive/plug-in-background.jpg");
  align-content: center;

  .section-container {
    @include display-flex(flex, wrap);
    justify-content: flex-end;
    text-align: right;
    padding: calc(2 * var(--page-offset)) calc(2 * var(--page-offset))
      var(--page-offset);
    padding-top: 5rem !important;

    .section-wrapper {
      width: 50%;

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header-sub {
        color: $mmc-blue;
        font-size: 1.6rem;
      }
    }
  }
}

.text-two-images {
  p {
    span {
      @include font-size-color(0.8rem, $slider-description);
      display: block;
      margin-top: 1rem;
    }
  }
}
</style>
